import VueI18n from 'vue-i18n-legacy'
import { createI18n } from 'vue-i18n'

import { provideVue18n } from './useI18n'

import fr_farmi from './farmi/fr-FR.json'
import fr_aladin from './aladin/fr-FR.json'
import fr_episens from './episens/fr-FR.json'
import en_countrymalt from './countrymalt/en-US.json'
import fr_countrymalt from './countrymalt/fr-CA.json'

import fr_default from './default/fr-FR.json'
import en_default from './default/en-US.json'

import fr_emoji from './emoji/fr-FR.json'
import { AppContext } from '@invivodf/common/app.context'

export const localeList = {
  aladin: {
    'fr-FR': fr_aladin,
  },
  farmi: {
    'fr-FR': fr_farmi,
  },
  episens: {
    'fr-FR': fr_episens,
  },
  countrymalt: {
    'en-US': en_countrymalt,
    'en-CA': en_countrymalt,
    'fr-CA': fr_countrymalt,
  },
  jardiland: {
    'fr-FR': fr_default,
  },
  gammvert: {
    'fr-FR': fr_default,
  },
  emoji: {
    'fr-FR': fr_emoji,
  },
}

export function initI18nForVue2(locale: string, Vue: any, fallbackLocale: string = 'fr') {
  const customBrandName = <AppContext | null>localStorage.getItem('customLocale')
  const brandName: AppContext = customBrandName || window.env.VUE_APP_CONTEXT

  Vue.use(VueI18n)

  const i18n = new VueI18n({
    messages: { ...localeList[brandName], fr: fr_default, en: en_default },
    locale,
    fallbackLocale,
  })

  provideVue18n(i18n)

  return i18n
}

export function initI18n(locale: string, fallbackLocale: string = 'fr', appContext: AppContext) {
  const customBrandName = <AppContext | null>localStorage.getItem('customLocale')
  const brandName = customBrandName || appContext

  return createI18n({
    locale,
    fallbackLocale,
    messages: { ...localeList[brandName], fr: fr_default, en: en_default },
    legacy: false
  })
}

export { VueI18n }
